import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'

export const TitleChart = ({ title, isI18n }) => {
  return (
    <Element elementName="span" className="fw600" style={{ color: '#191d25' }}>
      {isI18n ? <Translate value={title} /> : title}
    </Element>
  )
}

TitleChart.propTypes = {
  title: PropTypes.string.isRequired,
  isI18n: PropTypes.bool,
}

TitleChart.defaultProps = {
  isI18n: true,
}
